import { PaymentIntent, StripeError } from '@stripe/stripe-js';
import { PaymentMethodDto } from 'src/app/api/models';
import { CustomBookingDTO } from './global.model';

export interface PaymentStorageData {
	type: PaymentObject;
	id: any;
	paymentMethod: PaymentMethodEnum;
	paymentIds: PaymentIds;
}

export enum PaymentSlides {
	FreeHours = 0,
	PaymentStatus = 1,
	ChooseNewPaymentMethods = 2,
	AddNewCard = 3,
	ExistsPaymentMethods = 4,
}


export enum PaymentSlide {
	FreeHoursScree,
	SelectExistsPaymentMethod
}

export enum PayPalAction {
	Report,
	Cancel,
	Error,
	Subscription
}

export interface PaypalActionObj {
	action: PayPalAction;
	props?: any;
}

export interface PaymentIds {
	freeHours?: number;
	main: number;
	// paymentsToMethod?: { [key: string]: 'STRIPE_CARD' | 'STRIPE_GIROPAY' | 'PAYPAL' | 'FREE_HOURS' };
}

export interface CardConfirmResponse {
	paymentIntent?: PaymentIntent;
	error?: StripeError;
}

export interface CustomerPaymentMethod extends PaymentMethodDto {
	brandImg?: string;
	brandImg2?: string;
	brandImg3?: string;
	additionalText?: string;
	type?: PaymentMethodEnum;
}

export enum PaymentMethodEnum {
	STRIPE_CARD = 'STRIPE_CARD',
	STRIPE_GIROPAY = 'STRIPE_GIROPAY',
	PAYPAL = 'PAYPAL',
	FREE_HOURS = 'FREE_HOURS',
	PAYREXX_TWINT = 'PAYREXX_TWINT'
}


export interface PaymentInfo {
	method?: PaymentMethodEnum;
	currency?: string;
	amountToPay?: any;
	duration?: string;
	subscriptionDuration?: string;
	extraDuration?: string;
	from?: string;
	to?: string;
	groupName?: string;
	bookingId?: number;
	showSubsRow?: boolean;
	groupId?: number;
	freeHours?: number;
	freeHoursUsed?: number;
	bookingHours?: number;
	type?: PaymentObject;
	productType?: string;
	isPayedByFreeHours?: boolean;
	booking?: CustomBookingDTO;
	invoiceName?: string;
	paymentId?: any;
	purchase?: Purchase;
	date?: string;
	originDate?: string;
	status?: string;
	subscriptionStartDate?: string;
	recommendedFreeHours?: number;
	paymentMethods?: Array<'STRIPE_CARD' | 'PAYPAL' | 'PAYREXX_TWINT' | 'FREE_HOURS' | 'STRIPE_GIROPAY'>;
}

export interface Purchase {
	id: any;
	productsCounts?: number;
	purchaseDate?: string;
}

export enum PaymentObject {
	Subscription = 'subscription',
	PayPerUse = 'pay-per-use',
	Booking = 'booking',
	Purchase = 'purchase'
}

export interface PurchaseDto {
	cart_submission: number;
	currency: 'USD';
	id: number;
	is_active: true;
	is_paid: false;
	is_payment_initiated: false;
	orders: Array<number>;
	time_created: string;
	time_modified: string;
	total_price: string;
}

